import React, { FC, useState } from 'react';
import { Stepper } from '@ordr-as/umami-react/stepper';
import { useLocation } from '../../../../context/LocationContext';
import { CartAdditionOption } from '../../../../../types/cart';
import { isEqualOptionId } from '../../../../utils/cart';
import { OptionDto } from '../../../../../generated-api';

const findDefaultQuantity = (option: OptionDto, defaultOptions: CartAdditionOption[]) =>
  defaultOptions.find(isEqualOptionId(option))?.quantity || 0;

interface Props {
  option: OptionDto;
  onSelection: (option: OptionDto, quantity: number) => void;
  defaultOptions: CartAdditionOption[];
}

const OptionStepper: FC<Props> = ({ option, onSelection, defaultOptions }) => {
  const [optionQuantity, setOptionQuantity] = useState(findDefaultQuantity(option, defaultOptions));
  const { formatCurrency } = useLocation();

  const handleSelection = (nextQuantity: number) => {
    if (nextQuantity < 0) {
      setOptionQuantity(0);
      return;
    }

    setOptionQuantity(nextQuantity);
    onSelection(option, nextQuantity);
  };

  return (
    <div className="py-4 flex justify-between items-center">
      <p>{option.name}</p>
      <div className="flex items-center">
        <p className="mr-3">
          {option.takeawayPrice
            ? `${formatCurrency(option.price)} | ${formatCurrency(option.takeawayPrice)}`
            : formatCurrency(option.price)}
        </p>
        <Stepper
          quantity={optionQuantity}
          onIncrease={() => handleSelection(optionQuantity + 1)}
          onDecrease={() => handleSelection(optionQuantity - 1)}
        />
      </div>
    </div>
  );
};

export default OptionStepper;
